export default __webpack_public_path__ + "static/media/chat-bots-screen-3.4ddc5544.jpg";